import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {WinterHoardParsedGameData} from "../../server/data/IWinterHoardServerData";
import {Timeline, TimelineLite} from "gsap";
import {WinterHoardGameModuleConfig} from "../../WinterHoardGameModuleConfig";
import {SoundPlayer} from "../../sound/SoundPlayer";
import {WinterHoardSoundConfig} from "../../WinterHoardSoundConfig";


export class FeatureRestore implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;
    private _whData:WinterHoardParsedGameData;
    private _data:any;
    private _isRestore:boolean;
    private mode:string;
    private nextMode:string;


    private _energyCollectedBefore:number;
    private _energyCollectedAfter:number;
    private _energyCollectPositions:boolean [][] = [];
    private _energyCollected:number;

    private _symbolMultipliers:any; // make a hash/map typing

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }


    public getAnimation(data:any):Timeline | null {
        const tl:TimelineLite = new TimelineLite();
        let timelineSetup:Timeline [] = [];

        if(this._isRestore) {
            /*tl.add(() => {
                //console.log("RESTORE STATE: " + this._isRestore);
                //console.log(this._data);
            });*/
            WinterHoardGameModuleConfig.indicatorBackground.activateEnteringFS(this.mode);


            if (this._data.mode === "FREESPIN_TRANSFORM") {
                tl.add(() => {
                    WinterHoardGameModuleConfig.reelBackground.switchBg("fs");

                });
                tl.add(() => {
                    if(this._energyCollected >= 5) {
                        SoundPlayer.playEffect(WinterHoardSoundConfig.SYMBOL_CHANGE_ON_METER);
                    }
                }, 0.5);
                timelineSetup = WinterHoardGameModuleConfig.freeSpinCounterView.updateData(0, this._energyCollected, this._energyCollectPositions, this._isRestore, 0);
            } else if (this._data.mode === "FREESPIN_MULTIPLIER") {
                tl.add(() => {
                    WinterHoardGameModuleConfig.reelBackground.switchBg("fs");
                });
                tl.add(() => {
                    if(this._energyCollected >= 5) {
                        SoundPlayer.playEffect(WinterHoardSoundConfig.SYMBOL_CHANGE_ON_METER);
                    }
                }, 0.5);
                timelineSetup = WinterHoardGameModuleConfig.freeSpinMultiplierView.updateData(0, this._energyCollected, this._energyCollectPositions, this._symbolMultipliers, this._data.mode, this._isRestore, 0);
            } else if (this._data.mode === "FREESPIN_COMBINED") {
                tl.add(() => {
                    WinterHoardGameModuleConfig.reelBackground.switchBg("fs");
                });
                tl.add(() => {
                    if(this._energyCollected >= 5) {
                        SoundPlayer.playEffect(WinterHoardSoundConfig.SYMBOL_CHANGE_ON_METER);
                    }
                }, 0.5);
                timelineSetup = WinterHoardGameModuleConfig.freeSpinMultiplierView.updateData(0, this._energyCollected, this._energyCollectPositions, this._symbolMultipliers, this._data.mode, this._isRestore, 0);
            }

            timelineSetup.forEach((timeline) => {
                timeline.play();
            })
        }

        return tl;
    }

    public prepare(data:any):void {
        this._data = data;
        this._whData = <WinterHoardParsedGameData> data;
        this.mode = this._whData.mode;
        this.nextMode = this._whData.nextMode;

        this._isRestore =  (<any> data).isRestoreState;
        //this._numberText.text = "" + data.freespinsLeft;
        this._energyCollectedBefore = this._data.energyCollectedBefore;
        this._energyCollectedAfter = this._data.energyCollectedAfter;
        this._energyCollectPositions = this._data.energyCollectPositions;
        this._symbolMultipliers = this._data.symbolMultipliers;
        this._energyCollected = this._data.energyCollected;

        //debugger;

    }
}